module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('app-loading') : _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  })]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('div', {
    staticClass: "my-2 justify-end flex"
  }, [_c('DownloadParticipations', {
    attrs: {
      "activity": _vm.activity
    }
  })], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-report -mt-2"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("USUARIO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n              TIEMPO\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n              PORCENTAJE\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n              FECHA\n            ")]), _vm._v(" "), (_vm.activity.type === 'Extra') ? _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n              CALIFICACIÓN\n            ")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.users), function(activity_user) {
    return _c('tr', {
      key: ("activity-" + (activity_user.user.slug)),
      staticClass: "intro-x"
    }, [_c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-900 font-bold text-xs whitespace-no-wrap"
    }, [_c('a', {
      attrs: {
        "href": _vm.activity.image,
        "target": "_blank"
      }
    }, [_vm._v("\n                  " + _vm._s(activity_user.user.name) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                  " + _vm._s(activity_user.user.email) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_c('a', {
      attrs: {
        "href": _vm.activity.image,
        "target": "_blank"
      }
    }, [_vm._v("\n                    " + _vm._s(activity_user.user.team ? activity_user.user.team.name : '') + "\n                  ")])])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(activity_user.time_to_respond) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(activity_user.percentage_correct) + "%\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(activity_user.created_at) + "\n              ")])]), _vm._v(" "), (_vm.activity.type === 'Extra') ? _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(activity_user.qualification === null ? 'Sin Calificar' : (activity_user.qualification == true ? 'Aprobado' : 'Rechazado')) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "table-report__action w-56"
    }, [_c('div', {
      staticClass: "flex flex-wrap justify-center items-center"
    }, [(_vm.activity.type !== 'Extra') ? _c('router-link', {
      staticClass: "flex items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      attrs: {
        "to": ("/admin/activities/" + (activity_user.slug) + "/answers")
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "folder",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Ver\n                  Respuestas\n                ")], 1) : _vm._e(), _vm._v(" "), (_vm.activity.type === 'Extra' && activity_user.qualification === null) ? _c('button', {
      staticClass: "flex items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.showQualificationModal(activity_user.slug, activity_user.answer)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "eye",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Calificar\n                ")], 1) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "flex items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.showDeleteModal(activity_user.slug)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "trash",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Eliminar\n                  Participación\n                ")], 1)], 1)])])
  }), 0)])])]), _vm._v(" "), (_vm.showParticipationDeleteModal) ? _c('Modal', {
    attrs: {
      "title": "Eliminar Participación",
      "size": "lg"
    },
    on: {
      "close": _vm.closeDeleteModal
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitDeleteModal()
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "mt-3 col-span-12 text-center"
  }, [_c('div', [_vm._v("Esta seguro de eliminar la Participación?")])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeDeleteModal
    }
  }, [_vm._v("\n          Cancelar\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Eliminar\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.showParticipationQualificationModal) ? _c('Modal', {
    attrs: {
      "title": "Calificar Participación",
      "size": "lg"
    },
    on: {
      "close": _vm.closeQualificationModal
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "mt-3 col-span-12 text-center"
  }, [_c('div', [_vm._v(_vm._s(_vm.answer))]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 flex justify-center gap-5"
  }, [_c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitQualificationModal(true)
      }
    }
  }, [_vm._v("\n              Aprobar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-4 text-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitQualificationModal(false)
      }
    }
  }, [_vm._v("\n              Rechazar\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeQualificationModal
    }
  }, [_vm._v("\n          Cancelar\n        ")])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0021dac1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/activity/ListParticipations.vue
// module id = 399
// module chunks = 1